import { defineStore } from 'pinia'
import type { ComponentSize } from 'element-plus'

type Language = 'zh-CN' | 'en'

export interface OpenMenuTab {
  path: string
  fullPath: string
  title: string
  parentTitle?: string
}

export const MAX_OPEN_MENU_TABS = 5

export const useUiStore = defineStore('ui', {
  state: () => ({
    sidebarCollapsed: false,
    dark: false,
    language: 'zh-CN' as Language,
    componentSize: 'default' as ComponentSize,
    openMenuTabs: [] as OpenMenuTab[]
  }),
  actions: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },
    setDark(value: boolean) {
      this.dark = value
      document.documentElement.classList.toggle('dark', value)
    },
    setLanguage(value: Language) {
      this.language = value
    },
    openMenuTab(tab: OpenMenuTab) {
      const existing = this.openMenuTabs.find(item => item.path === tab.path)
      if (existing) Object.assign(existing, tab)
      else {
        if (this.openMenuTabs.length >= MAX_OPEN_MENU_TABS) this.openMenuTabs.shift()
        this.openMenuTabs.push(tab)
      }
    },
    closeMenuTab(path: string) {
      this.openMenuTabs = this.openMenuTabs.filter(item => item.path !== path)
    },
    closeAllMenuTabs() {
      this.openMenuTabs = []
    }
  },
  persist: {
    pick: ['sidebarCollapsed', 'dark', 'language', 'componentSize', 'openMenuTabs'],
    afterHydrate: ({ store }) => {
      store.openMenuTabs = store.openMenuTabs
        .map((tab: OpenMenuTab) => ({
          path: tab.path,
          fullPath: tab.fullPath || tab.path,
          title: tab.title,
          parentTitle: tab.parentTitle
        }))
        .slice(-MAX_OPEN_MENU_TABS)
      document.documentElement.classList.toggle('dark', store.dark)
    }
  }
})
